var SortDataPie = function (processedData) {

  var result = [];
  for (var j = 0; j < processedData.length; j++) {

      var p = {};
      var obj = processedData[j];
      var legendKey = obj.legendKey;
      var seriesKey = obj.seriesKey;

      if (Object.keys(result).length == 0) {
          p['legendKey'] = legendKey;
          p['seriesKey'] = seriesKey;
          result.push(p);
      } else {

          var exist = false;
          for (var i = 0; i < Object.keys(result).length; i++) {
              var obj2 = result[i];
              var ledendKey2 = obj2.legendKey;
              var seriesKey2 = obj2.seriesKey;

              if (ledendKey2 == legendKey) {
                  seriesKey += seriesKey2;
                  obj2.seriesKey = seriesKey;
                  exist = true;
                  break;
              }

          }
          if (!exist) {
              p['legendKey'] = legendKey;
              p['seriesKey'] = seriesKey;
              result.push(p);
          }
      }
  }

  return result;
}

exports.SortDataPie=SortDataPie;



//////////////////
// WEBPACK FOOTER
// ./src/modules/SortDataPie/SortDataPie.js
// module id = 10
// module chunks = 0